<template>
    <block-section>
        <breadcrumb />
        <layout-split :headline="headline" reverse>
            <template v-slot:primary>
                <text-headline-secondary>
                    {{ texts.product_information_title }}
                </text-headline-secondary>

                <block-travel-information />
            </template>

            <template v-slot:secondary>
                <form @submit.prevent="proceedToPayment">
                    <block-delivery-information class="delivery-information" />

                    <ul v-if="isRetireeTicket" class="bullets">
                        <li v-for="(txt, index) in texts.retiree_ticket_bullets" :key="index">
                            {{ txt }}
                        </li>
                    </ul>

                    <div class="field">
                        <field-customer-terms-accept>
                            <span>{{ confirm_button_part_one }} </span>
                            <a class="readmore" @click="$modal.show('content-page-modal')">{{ confirm_button_link }}</a>
                            <span> {{ confirm_button_part_two }} </span>
                        </field-customer-terms-accept>
                    </div>

                    <div class="field">
                        <field-customer-privacy-policy>
                            <span>{{ texts.confirm_privacy_policy_text }} </span>
                            <a class="readmore" target="_blank"
                                href="https://www.midttrafik.dk/kundeservice/privatlivspolitik/">{{
                                    texts.confirm_button_privacy_link }}</a>
                            <span> {{ "." }} </span>
                        </field-customer-privacy-policy>
                    </div>

                    <div v-if="deliveryMethod === 'snailmail'" class="field">
                        <field-customer-delivery-terms-accept>
                            {{ texts.delivery_terms }}
                            <div style="font-weight: 800">
                                {{ texts.delivery_terms_note }}
                            </div>
                        </field-customer-delivery-terms-accept>
                    </div>

                    <div class="payment-btn-container">
                        <ApplePayCheckoutButton class="payment-btn"></ApplePayCheckoutButton>
                        <text-button class="payment-btn card-btn" type="submit" :disabled="!isStepValid">
                            <div v-if="isFree">
                                {{ texts.approve_and_go_to_free_payment }}
                            </div>
                            <div v-else>
                                {{ texts.approve_and_go_to_payment }}
                            </div>
                        </text-button>
                    </div>

                    <modal-content-page :name="termsContentPageIdentifier" />
                </form>
            </template>
        </layout-split>
    </block-section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import FieldCustomerTermsAccept from "@/components/fields/FieldCustomerTermsAccept";
import FieldCustomerDeliveryTermsAccept from "@/components/fields/FieldCustomerDeliveryTermsAccept";
import TextButton from "@/components/elements/TextButton";
import BlockTravelInformation from "@/components/blocks/BlockTravelInformation";
import BlockDeliveryInformation from "@/components/blocks/BlockDeliveryInformation";
import ApplePayCheckoutButton from "../components/payment/ApplePayCheckoutButton";
const ModalContentPage = () =>
    import(
            /* webpackMode: "lazy", webpackChunkName: "modal-content-page" */ "@/components/modals/ModalContentPage"
    );

export default {
    components: {
        ApplePayCheckoutButton,
        FieldCustomerTermsAccept,
        FieldCustomerDeliveryTermsAccept,
        TextButton,
        BlockTravelInformation,
        BlockDeliveryInformation,
        ModalContentPage
    },
    computed: {
        termsContentPage() {
            switch (this.$i18n.locale) {
                case "da":
                    return "WebshopTermsAndConditionsDanish";
                default:
                    return "WebshopTermsAndConditionsEnglish";
            }
        },
        texts() {
            return this.$t("page_confirm_basket");
        },
        isRetireeTicket() {
            return (
                this.$store.state.products.retireeticket.info &&
                this.$store.state.order.productType ===
                this.$store.state.products.retireeticket.info.identifier
            );
        },
        isFree() {
            return this.paymentProvider == "Free";
        },
        headline() {
            switch (this.deliveryMethod) {
                case 'controlfee':
                    return this.texts.title_payment;
                default:
                    return this.texts.title;
            }
        },
        confirm_button_part_one() {
            switch (this.deliveryMethod) {
                case 'controlfee':
                    return this.texts.confirm_button_part_one_controlfee;
                default:
                    return this.texts.confirm_button_part_one;
            }
        },
        confirm_button_link() {
            switch (this.deliveryMethod) {
                case 'controlfee':
                    return this.texts.confirm_button_link_controlfee;
                default:
                    return this.texts.confirm_button_link;
            }
        },
        confirm_button_part_two() {
            switch (this.deliveryMethod) {
                case 'controlfee':
                    return this.texts.confirm_button_part_two_controlfee;
                default:
                    return this.texts.confirm_button_part_two;
            }
        },
        termsContentPageIdentifier() {
            switch (this.deliveryMethod) {
                case 'controlfee':
                    return "WebshopControlFeeConditions";
                default:
                    return "WebshopTermsAndConditions";
            }
        },
        ...mapGetters({
            isStepValid: "flow/isStepValid",
            deliveryMethod: "order/getDeliveryMethod",
            paymentProvider: "order/getPaymentProvider"
        })
    },
    methods: {
        onCancel: () => {
            console.log("On cancel");
        },
        proceedToPayment() {
            this.setPaymentProvider(null);
            this.nextStep();
        },
        setPaymentProvider(provider) {
            this.$store.commit("order/setPaymentProvider", provider);
        },
        ...mapActions({
            nextStep: "flow/gotoNextStep"
        }),
    }
};
</script>

<style scoped lang="scss">
.delivery-information {
    margin-bottom: 2rem;
}

.field {
    margin-bottom: 2rem;
}

.bullets {
    margin-bottom: 2rem;
    padding-left: 1.5rem;

    li {
        margin-bottom: 1rem;
    }
}

.payment-btn-container {
    display: flex;
    justify-content: left;
    align-items: center;

    .payment-btn {
        margin: 10px 20px 10px 0px;
        height: 45px;
        padding-top: 0;
        padding-bottom: 0;
    }

    .card-btn {
        font-weight: unset;
        padding: 15px;
    }
}
</style>
